import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const ANNOUNCEMENTS_AS_OF_PREFIX = 'As of';

export const ANNOUNCEMENTS_EMPTY_TEXT = 'No lender announcements right now.';

export const AnnouncementSeverity = {
  IMPORTANT: 'Important',
  INFO: 'Info',
};

export const ANNOUNCEMENT_SEVERITY_LABEL_VARIANT = {
  [AnnouncementSeverity.IMPORTANT]: LabelVariant.RED,
  [AnnouncementSeverity.INFO]: LabelVariant.BLUE,
};
